import React, { useState } from "react";
import { motion } from "framer-motion";
import { ShieldCheck, ArrowLeft } from "lucide-react";

export default function Consent({ onAccept, onBack, onPrivacy }) {
  const [checked, setChecked] = useState(false);
  return (
    <div className="fs-container py-8 fs-fade-up">
      <button onClick={onBack} className="flex items-center gap-1.5 text-sm text-[var(--fs-ink-2)] mb-6 fs-focus rounded" data-testid="consent-back-button">
        <ArrowLeft size={16} /> Indietro
      </button>

      <span className="grid place-items-center w-12 h-12 rounded-2xl bg-[var(--fs-tint)] text-[var(--fs-blue)]">
        <ShieldCheck size={22} />
      </span>
      <h1 className="text-2xl font-bold mt-4">Prima di iniziare</h1>
      <p className="mt-3 text-[var(--fs-ink-2)] leading-relaxed">
        Per creare il tuo Skin Profile abbiamo bisogno di analizzare temporaneamente alcune fotografie del tuo volto.
      </p>

      <motion.label
        whileTap={{ scale: 0.995 }}
        className={`mt-6 flex items-start gap-3 p-4 rounded-2xl border cursor-pointer transition-colors ${
          checked ? "border-[var(--fs-blue)] bg-[var(--fs-tint)]" : "border-[var(--fs-border)] bg-white"
        }`}
        data-testid="consent-checkbox-label"
      >
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
          className="mt-1 w-5 h-5 accent-[var(--fs-blue)] shrink-0"
          data-testid="consent-checkbox"
        />
        <span className="text-sm text-[var(--fs-ink)] leading-relaxed">
          Acconsento all'utilizzo delle immagini del mio volto esclusivamente per generare lo Skin Check richiesto.
        </span>
      </motion.label>

      <button onClick={onPrivacy} className="mt-4 text-sm text-[var(--fs-blue)] underline underline-offset-2 fs-focus rounded" data-testid="consent-privacy-link">
        Leggi l'informativa privacy
      </button>

      <div className="mt-6 p-4 rounded-2xl bg-slate-50 border border-[var(--fs-border)]">
        <p className="text-sm text-[var(--fs-ink-2)]">
          Skin Analyzer non effettua riconoscimento dell'identità e non fornisce diagnosi mediche.
        </p>
      </div>

      <button
        onClick={onAccept}
        disabled={!checked}
        className="fs-btn-primary w-full py-4 mt-8 fs-focus"
        data-testid="consent-continue-button"
      >
        CONTINUA
      </button>
    </div>
  );
}
